import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yahoo",
  "use": "icon-yahoo-usage",
  "viewBox": "0 0 342 449",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 342 449\" id=\"icon-yahoo\">\n<g>\n\t<path fill=\"#6A1B9A\" d=\"M330.7,0h-53.3c-3.9,0-7.5,2.1-9.3,5.5l-97.3,175.2L73.3,5.5C71.5,2.1,67.9,0,64,0H10.7C4.8,0,0,4.8,0,10.7\n\t\tc0,1.8,0.5,3.7,1.4,5.3l137.1,242.6L128,436.7c-0.3,5.9,4.1,10.9,10,11.3c0.2,0,0.4,0,0.6,0h64c5.9,0,10.7-4.8,10.7-10.6\n\t\tc0-0.2,0-0.4,0-0.6l-10.5-178.2L340,15.9c2.9-5.1,1.1-11.6-4-14.5C334.3,0.5,332.5,0,330.7,0z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/yahoo.svg
// module id = 188
// module chunks = 0 1 2